import { cn } from '@/lib/utils'

export interface ScrollIndicatorsProps {
  total: number
  activeIndex: number
  className?: string
}

export function ScrollIndicators({
  total,
  activeIndex,
  className,
}: ScrollIndicatorsProps) {
  if (total <= 1) return null

  return (
    <div
      className={cn('mt-3 flex justify-center gap-1.5 sm:hidden', className)}
      aria-label="Scroll position indicators"
    >
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          className={cn(
            'h-1.5 rounded-full transition-all duration-300',
            index === activeIndex
              ? 'w-4 bg-[#0033A0]'
              : 'w-1.5 bg-muted-foreground/30'
          )}
          aria-current={index === activeIndex ? 'true' : undefined}
        />
      ))}
    </div>
  )
}
